import { Autocomplete, Button, FormHelperText, Grid2, TextField, Typography, useTheme } from '@mui/material';
import { Formik } from 'formik';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dispatch } from 'store';
import { useUpdateWorkFlowPMMutation } from 'store/slices/apis/keyPMSlice';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import * as Yup from 'yup';

const currentStatuses = [
    { label: "Approve" },
    { label: "Reject" },
];

export default function PMComment(props) {
    const { id, rowData } = props;
    const theme = useTheme();
    const navigate = useNavigate();
    const { projectId } = useParams();
    const formikRef = React.useRef();
    const [updateWorkFlow, updateWorkFlowRes] = useUpdateWorkFlowPMMutation();
    const [formData, setFormData] = React.useState({
        comment: '',
        status: '',
        id: id
    })

    const handleSubmit = async (values) => {
        //const formdata = new FormData();
        //Object.entries(values).forEach(([key, value]) => {
        //formdata.append(key, value);
        //});
        await updateWorkFlow({ ...values, parentId: rowData?.id, data: JSON.stringify(rowData) })
        //await updateWorkFlow(formdata)
    }


    React.useEffect(() => {
        if (updateWorkFlowRes?.isSuccess) {
            if (updateWorkFlowRes?.data?.status?.toLowerCase() == 'success') {

                formikRef.current?.resetForm();
                openNotification(updateWorkFlowRes?.data?.message, 'success')
                navigate(`/projects/${projectId}/my-work`);
            } else {
                openNotification(updateWorkFlowRes?.data?.message, 'error')
            }
        }
    }, [updateWorkFlowRes?.isSuccess]);

    React.useEffect(() => {
        if (updateWorkFlowRes?.isError) {
            if (updateWorkFlowRes?.error?.data?.status == 'fail') {
                openNotification(updateWorkFlowRes?.error?.data?.message, 'error')
            } else {
                openNotification(updateWorkFlowRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [updateWorkFlowRes?.isError]);

    const validationSchema = Yup.object({
        status: Yup.string().required("Status field is required."),
        comment: Yup.string().required("Comment field is required.")
    });

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={12}>
                            <Autocomplete
                                options={currentStatuses}
                                getOptionLabel={(option) => option?.label}
                                value={currentStatuses.find((option) => option.label === values?.status) || null}
                                onChange={(_, newValue) => setFieldValue("status", newValue ? newValue.label : "")}
                                onBlur={() => setTouched({ ...touched, status: true })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        placeholder='Select status'
                                        name="status"
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        variant="filled"
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: "13px" },
                                }}
                            />
                            {touched?.status && errors?.status &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.status}`}</FormHelperText>
                            }
                        </Grid2>
                        <Grid2 size={12}>
                            <TextField
                                id="outlined-multiline-static"
                                label="Comment"
                                name="comment"
                                multiline
                                fullWidth
                                rows={3}
                                value={values?.comment}
                                onChange={handleChange}
                                onBlur={() => setTouched({ ...touched, comment: true })}
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                            />
                            {touched?.comment && errors?.comment &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.comment}`}</FormHelperText>
                            }
                        </Grid2>

                        <Grid2 size={12}>
                            <Button type='submit'
                                variant="contained"
                                loading={updateWorkFlowRes?.isLoading}
                                sx={{
                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    textTransform: 'none',
                                    float: 'right'
                                }}>
                                Save
                            </Button>
                        </Grid2>
                    </Grid2>
                </form>
            )}
        </Formik>
    );
}